import format from 'date-fns/format';

const handleYearlyQuarter = (
  month: number
): ReturnType<typeof handleFormattedDateByPeriodicValue> => {
  const today = new Date();

  let start_date = '';
  const end_date = format(today, 'yyyy-MM-dd');

  switch (month) {
    case 0:
    case 1:
    case 2: {
      start_date = format(new Date(new Date().getFullYear(), 0, 1), 'yyyy-MM-dd');
      break;
    }
    case 3:
    case 4:
    case 5: {
      start_date = format(new Date(new Date().getFullYear(), 3, 1), 'yyyy-MM-dd');
      break;
    }
    case 6:
    case 7:
    case 8: {
      start_date = format(new Date(new Date().getFullYear(), 6, 1), 'yyyy-MM-dd');
      break;
    }
    case 9:
    case 10:
    case 11: {
      start_date = format(new Date(new Date().getFullYear(), 9, 1), 'yyyy-MM-dd');
      break;
    }
    default: {
      throw new Error('Invalid month');
    }
  }

  return {
    start_date,
    end_date,
  };
};


const handleFormattedDateByPeriodicValue = (period : string) : {start_date: string; end_date?: string}=> {
  const today = new Date();
  switch (period) {
    case "0":
      return {
        start_date: format(new Date(), 'yyyy-MM-dd'),
        end_date: format(new Date(), 'yyyy-MM-dd'),
      };
    case "6": {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      return {
        start_date: format(yesterday, 'yyyy-MM-dd'),
        end_date: format(yesterday, 'yyyy-MM-dd'),
      };
    }
    case "1": {
      const startDate = new Date();
      const endDate = new Date();
      startDate.setDate(1);

      return {
        start_date: format(startDate, 'yyyy-MM-dd'),
        end_date: format(endDate, 'yyyy-MM-dd'),
      };
    }
    case "2": {
      const previousMonth = new Date(today);
      previousMonth.setMonth(new Date().getMonth() - 1);
      previousMonth.setDate(1);

      return {
        start_date: format(previousMonth, 'yyyy-MM-dd'),
        end_date: format(today, 'yyyy-MM-dd'),
      };
    }
    case "3": {
      return handleYearlyQuarter(today.getMonth());
    }
    case "12": {
      const begginingOfTheYear = new Date(today);
      begginingOfTheYear.setMonth(0);
      begginingOfTheYear.setDate(1);

      return {
        start_date: format(begginingOfTheYear, 'yyyy-MM-dd'),
        end_date: format(today, 'yyyy-MM-dd'),
      };
    }
  }
};

const downloadFileWithAnchorTag = (url : string) => {
  const anchorElement = document.createElement("a");
  document.body.appendChild(anchorElement);
  anchorElement.href = `${url}`;
  anchorElement.target = "_blank";
  anchorElement.download = `${url}`;
  anchorElement.click();
  document.body.removeChild(anchorElement);
};

export { handleFormattedDateByPeriodicValue , downloadFileWithAnchorTag };